export default __webpack_public_path__ + "static/media/terms_conditions.8f2257a8.docx";